import Analytic from '@commons/cards/analytic'
import Column from '@components/column'
import Grid from '@components/grid'
import Tab from '@components/tabs'
import Title from '@components/title'
import AdminCreated from './admin-created'
import PlayerCreated from './player-created'
import { useNavigate } from 'react-router-dom'
import { totalMatchrooms } from '@assets/icons'
import DashboardCard from '@commons/cards/dashboard'
const cardConfig = [
  {
    key: 'totalMatches',
    title: 'Total Matchrooms',
    icon: totalMatchrooms,
    isUp: true,
    link: '/admin/game-management/match-rooms',
  },
  {
    key: 'totalMatchesOnGoing',
    title: 'Active Matchrooms',
    icon: totalMatchrooms,
    isUp: false,
    link: '/admin/game-management/match-results?tab=Awaiting Results',
  },
  {
    key: 'totalMatchesCreatedByAdmin',
    title: 'Admin Created Matchroom',
    icon: totalMatchrooms,
    isUp: false,
    link: '/admin/game-management/match-results?tab=Admin Created',
  },
  {
    key: 'totalMatchesCreatedByUser',
    title: 'Player Created Matchroom',
    icon: totalMatchrooms,
    isUp: false,
    link: '/admin/game-management/match-results?tab=Player Created',
  },
]
const MatchRooms = () => {
  const navigate = useNavigate()
  const items = [
    { label: 'Admin Created', component: AdminCreated },
    { label: 'Player Created', component: PlayerCreated },
  ]
  return (
    <>
      <Column>
        <DashboardCard cardConfig={cardConfig} />

        <Title
          textone="Game Management >"
          texttwo="Match Rooms"
          hasButton
          btnText="Create Room"
          onButtonClick={() =>
            navigate('/admin/game-management/match-rooms/create-matchroom')
          }
        />

        <Tab items={items} />
      </Column>
    </>
  )
}
export default MatchRooms
